// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionSteps_SaveAdditionalServiceStepsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for POST /so/production_steps/save_additional_service_steps
 *
 * Replaces all step assignments for an additional service. Wire shape:
 * `{ count, steps, reordered }`. Failure paths use $this->sendError('...').
 *
 * Same normalization contract as the service-steps sibling: `steps` is the
 * list as stored and `reordered` says whether the terminal-block rule moved
 * anything.
 */
import type { ProductionSteps_SavedStepRow } from './ProductionSteps_SavedStepRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ProductionSteps_SaveAdditionalServiceStepsResponseDados {
count: number
steps: ProductionSteps_SavedStepRow[]
reordered: boolean
}

export type ProductionSteps_SaveAdditionalServiceStepsResponse = ApiResponse<ProductionSteps_SaveAdditionalServiceStepsResponseDados>;

registerResponseContract('ProductionSteps_SaveAdditionalServiceStepsResponse', {
  count:     { type: 'number',  required: true },
  steps: {
    type: 'array',
    required: true,
    items: {
      production_step_id: { type: 'number',  required: true },
      is_terminal:        { type: 'number',  required: false },
      order:              { type: 'number',  required: false },
    },
  },
  reordered: { type: 'boolean', required: true },
})
